(() => {
  const CAROUSEL_SELECTOR = '.ext-testimonials--mobile-compact slider-component';

  class CompactTestimonialsCarousel {
    static initializeAll(scope = document) {
      scope.querySelectorAll(CAROUSEL_SELECTOR).forEach((component) => {
        if (component.dataset.compactCarouselInitialized === 'true') return;

        const carousel = new CompactTestimonialsCarousel(component);
        carousel.initialize();
      });
    }

    constructor(component) {
      this.component = component;
      this.slider = component.querySelector('.multicolumn-list');
      this.slides = Array.from(component.querySelectorAll('.multicolumn-list__item'));
      this.dots = Array.from(component.querySelectorAll('.ext-testimonial__dot'));
      this.animationFrame = null;

      this.handleScroll = this.handleScroll.bind(this);
    }

    initialize() {
      if (!this.slider || this.slides.length === 0 || this.dots.length === 0) return;

      this.component.dataset.compactCarouselInitialized = 'true';
      this.slider.addEventListener('scroll', this.handleScroll, { passive: true });

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.scrollToSlide(index));
      });

      this.updateActiveDot();
    }

    handleScroll() {
      window.cancelAnimationFrame(this.animationFrame);
      this.animationFrame = window.requestAnimationFrame(() => this.updateActiveDot());
    }

    updateActiveDot() {
      const sliderCenter = this.slider.scrollLeft + this.slider.clientWidth / 2;
      let activeIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(slideCenter - sliderCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      this.setActiveDot(activeIndex);
    }

    setActiveDot(activeIndex) {
      this.dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);

        if (isActive) {
          dot.setAttribute('aria-current', 'true');
          return;
        }

        dot.removeAttribute('aria-current');
      });
    }

    scrollToSlide(index) {
      const slide = this.slides[index];
      if (!slide) return;

      const centeredPosition =
        slide.offsetLeft - (this.slider.clientWidth - slide.offsetWidth) / 2;

      this.slider.scrollTo({
        left: centeredPosition,
        behavior: 'smooth',
      });
    }
  }

  const initializeCarousels = (scope = document) => {
    CompactTestimonialsCarousel.initializeAll(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCarousels());
  } else {
    initializeCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeCarousels(event.target);
  });
})();
